/**
 * Safely decodes a base64-encoded `continue` query parameter and validates
 * that the resulting URL belongs to the current origin and does not point to
 * an auth page. Returns `null` when validation fails so callers can fall back
 * to the default post-login route.
 */
const parseContinueUrl = (
  encoded: string | null,
  currentOrigin = window.location.origin
): string | null => {
  if (!encoded) {
    return null;
  }

  let decoded: string;
  try {
    decoded = atob(encoded);
  } catch {
    return null;
  }

  let url: URL;
  try {
    url = new URL(decoded);
  } catch {
    return null;
  }

  if (url.origin !== currentOrigin) {
    return null;
  }

  if (url.pathname.startsWith('/auth')) {
    return null;
  }

  return url.pathname + url.search + url.hash;
};

export default parseContinueUrl;
